export default __webpack_public_path__ + "static/talkNlpsummit-a1f71c6f8bbe69b68ed11d49fa9c379c.png";